(function(){
  function init(){
    var root=document.getElementById('sw-live-quiz');
    if(!root || root.dataset.ready==='1') return;
    root.dataset.ready='1';

    var data=[
      {q:'When you finally get a quiet moment, what do you notice first?',a:[
        'I feel numb, exhausted, or like I don’t even know what I need anymore.',
        'I can feel myself wanting more space, rest, and simple routines again.',
        'I’m noticing old patterns and asking deeper questions about myself.',
        'I feel ready to build something different instead of repeating the same cycle.',
        'I know what I want, but I don’t want to keep doing it alone.'
      ]},
      {q:'How would you describe your energy lately?',a:[
        'Drained — I’m running on empty.',
        'Up and down — some good days, some really hard days.',
        'Shifting — I’m starting to feel small pockets of hope again.',
        'More steady — I have more good days than bad.',
        'Aligned — I feel motivated and excited about what’s next.'
      ]},
      {q:'What feels like the hardest part right now?',a:[
        'Managing my thoughts, emotions, or stress.',
        'My physical health, weight, or energy.',
        'Old patterns, habits, or relationships.',
        'Feeling directionless or unsure what’s next.',
        'Feeling alone, even when I’m around others.'
      ]},
      {q:'What are you craving more of?',a:[
        'More self-love, confidence, and feeling like myself again.',
        'Rest, healing, and taking care of my body.',
        'Clarity, guidance, and a clearer next step.',
        'A supportive community who gets it.',
        'A fresh start and a new way of living.'
      ]},
      {q:'How do your routines feel right now?',a:[
        'Overwhelmed — I don’t have any real routines right now.',
        'Inconsistent — I start and stop a lot.',
        'I’m slowly rebuilding healthier habits.',
        'Mostly consistent — and I feel better when I stick to them.',
        'I have routines that support the life I want.'
      ]},
      {q:'How connected do you feel to yourself?',a:[
        'Disconnected — I don’t feel like myself.',
        'A little disconnected — but I’m starting to come back.',
        'I’m learning and rediscovering who I am.',
        'Pretty connected — I trust myself more than I used to.',
        'Deeply connected — I know who I am and what I need.'
      ]},
      {q:'What kind of support sounds most useful right now?',a:[
        'Gentle guidance and mindset support.',
        'Tools for my health, habits, and daily routines.',
        'A community and accountability.',
        'Clarity on my next steps, personal or business.',
        'A mix of all of the above.'
      ]},
      {q:'When you think about what comes next, how do you feel?',a:[
        'I’m scared, overwhelmed, or unsure.',
        'Cautiously hopeful — I feel a shift happening.',
        'Excited, but I could use some guidance.',
        'Ready — I know it’s time for something new.',
        'I’m fully ready to create the life I love.'
      ]}
    ];

    var answers=new Array(data.length).fill(null), index=0;
    var welcome=root.querySelector('.swq-welcome');
    var question=root.querySelector('.swq-question');
    var result=root.querySelector('.swq-result');
    var title=root.querySelector('.swq-title');
    var options=root.querySelector('.swq-options');
    var count=root.querySelector('.swq-count');
    var dots=root.querySelector('.swq-dots');
    var next=root.querySelector('.swq-next');
    var back=root.querySelector('.swq-back');

    function renderDots(){
      dots.innerHTML='';
      data.forEach(function(_,i){
        var d=document.createElement('span');
        d.className='swq-dot'+(i===index?' active':'');
        dots.appendChild(d);
      });
    }

    function render(){
      count.textContent='Question '+(index+1)+' of '+data.length;
      title.textContent=data[index].q;
      options.innerHTML='';
      data[index].a.forEach(function(label,i){
        var b=document.createElement('button');
        b.type='button';
        b.className='swq-option'+(answers[index]===i?' selected':'');
        b.setAttribute('role','radio');
        b.setAttribute('aria-checked',answers[index]===i?'true':'false');
        b.innerHTML='<span class="swq-radio" aria-hidden="true"></span><span>'+label+'</span>';
        b.addEventListener('click',function(){
          answers[index]=i;
          render();
        });
        options.appendChild(b);
      });
      back.disabled=index===0;
      next.disabled=answers[index]===null;
      next.textContent=index===data.length-1?'See My Result →':'Next →';
      renderDots();
    }

    function showQuestion(){
      welcome.hidden=true; result.hidden=true; question.hidden=false;
      render();
      root.scrollIntoView({behavior:'smooth',block:'start'});
    }

    var startButton=root.querySelector('.swq-start');
    if(startButton) startButton.addEventListener('click',function(e){e.stopPropagation();showQuestion();});
    if(welcome) welcome.addEventListener('click',showQuestion);

    back.addEventListener('click',function(){
      if(index>0){index--;render();}
    });

    next.addEventListener('click',function(){
      if(answers[index]===null) return;
      if(index<data.length-1){index++;render();return;}
      showResult();
    });

    root.querySelector('.swq-retake').addEventListener('click',function(){
      answers=new Array(data.length).fill(null);index=0;showQuestion();
    });

    function showResult(){
      var total=answers.reduce(function(s,n){return s+(n===null?0:n);},0);
      var avg=total/answers.length, r;
      if(avg<0.8){
        r={title:'Come Back to You',copy:'You do not need a huge transformation plan right now. You need a gentle place to begin. Come Back to You is a 7-day reset designed to help you slow down, check in with yourself, and reconnect with what you need.',label:'Start the 7-Day Reset',url:'/products/come-back-to-you'};
      }else if(avg<1.7){
        r={title:'Find Me Again',copy:'You are beginning to notice yourself again, but you may still feel disconnected or unsure what comes next. Find Me Again is a 13-day healing journey for reconnecting with your voice, needs, patterns, and sense of self.',label:'Begin Find Me Again',url:'/products/find-me-again'};
      }else if(avg<2.6){
        r={title:'Remember Me',copy:'You are already doing some of the remembering. Your next step is going deeper and staying connected to yourself while real life keeps happening. Remember Me is a 30-day deeper awakening journey.',label:'Explore Remember Me',url:'/products/remember-me'};
      }else if(avg<3.4){
        r={title:'Becoming Me',copy:'You are ready to move from awareness into consistent change. Becoming Me is a 90-day transformation journey for practicing the habits, boundaries, self-trust, and choices that support the life you are building.',label:'Start Becoming Me',url:'/products/becoming-me'};
      }else{
        r={title:'Personalized Support',copy:'You have clarity and momentum. Your next step may be less about finding another answer and more about having support, accountability, and a place to keep moving forward in a way that fits your life.',label:'Explore Coaching & Support',url:'/collections/coaching-services'};
      }
      question.hidden=true;welcome.hidden=true;result.hidden=false;
      root.querySelector('.swq-result-title').textContent=r.title;
      root.querySelector('.swq-result-copy').textContent=r.copy;
      var link=root.querySelector('.swq-result-link');link.textContent=r.label;link.href=r.url;
      root.scrollIntoView({behavior:'smooth',block:'start'});
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();

(function(){
function initBodyQuiz(){
var root=document.getElementById('swb');if(!root||root.dataset.bodyReady==='1')return;root.dataset.bodyReady='1';
var questions=[
{q:"What best describes why you're here today?",a:["I want help with weight management or metabolic wellness.","I'm already using a GLP-1 or another compound and want better support.","I'm curious about peptides/compounds and want to understand them before deciding anything.","I want to feel better overall—energy, nutrition, movement, recovery, digestion, sleep, etc.","I'm not really sure what I need. I just know something needs to change."],w:[{glp1:3,whole:1},{glp1:4,personal:1},{peptide:4,explore:1},{whole:4},{explore:2,personal:1}]},
{q:"What would be most helpful right now?",a:["Understanding my options and how they differ.","Understanding the research, benefits being studied, risks and limitations.","Getting my nutrition, hydration, protein and everyday habits working better.","Understanding side effects or challenges I'm experiencing and what information I should know.","Having someone help me sort through all this information because I'm overwhelmed."],w:[{explore:3,peptide:1,glp1:1},{peptide:3,explore:2},{whole:3,glp1:2},{glp1:3,explore:1},{personal:5}]},
{q:"Where are you in the process?",a:["I'm just researching.","I'm considering starting something but haven't decided.","I'm already using something and want to understand it better.","What I'm doing isn't giving me the experience/results I expected.","I don't know where to begin."],w:[{explore:4},{explore:2,peptide:1},{glp1:3,peptide:1},{glp1:3,personal:2},{explore:2,personal:1}]},
{q:"What areas are you most interested in?",help:"Choose all that apply.",multi:true,a:["Weight / metabolic goals","Energy","Protein / nutrition","Hydration","Digestion / constipation","Movement","Recovery","Sleep","Body composition","General wellness","Understanding GLP-1s","Understanding peptides / compounds","Side effects / tolerability","Something else"],w:[{glp1:2,whole:1},{whole:2},{whole:2,glp1:1},{whole:2,glp1:1},{glp1:2,whole:1},{whole:2},{whole:2},{whole:2},{glp1:2,whole:1},{whole:3},{glp1:3,explore:1},{peptide:3,explore:1},{glp1:3},{explore:1}]},
{q:"How much support do you want?",a:["Just give me trustworthy information—I like researching on my own.","Give me a starting point and resources so I can keep learning.","I'd like some guidance making sense of the information.","I want more personal support and would like to talk with Renee."],w:[{explore:4},{explore:3},{personal:3},{personal:7}]}
];
var ans=[null,null,null,[],null],i=0,w=root.querySelector('[data-s="w"]'),qbox=root.querySelector('[data-s="q"]'),rbox=root.querySelector('[data-s="r"]'),opts=root.querySelector('[data-opts]'),next=root.querySelector('[data-next]'),back=root.querySelector('[data-back]');
function render(){var x=questions[i];root.querySelector('[data-count]').textContent='Question '+(i+1)+' of '+questions.length;root.querySelector('[data-q]').textContent=x.q;root.querySelector('[data-help]').textContent=x.help||'';var p=root.querySelector('.prog');p.innerHTML='';questions.forEach(function(_,n){var d=document.createElement('span');d.className='dot'+(n===i?' on':'');d.textContent=n+1;p.appendChild(d);});opts.innerHTML='';x.a.forEach(function(label,n){var b=document.createElement('button');b.type='button';b.className='opt'+((x.multi?ans[i].indexOf(n)>-1:ans[i]===n)?' sel':'');b.innerHTML='<span class="let">'+String.fromCharCode(65+n)+'</span><span>'+label+'</span>';b.onclick=function(){if(x.multi){var k=ans[i].indexOf(n);k>-1?ans[i].splice(k,1):ans[i].push(n);}else ans[i]=n;render();};opts.appendChild(b);});back.disabled=i===0;next.disabled=x.multi?ans[i].length===0:ans[i]===null;next.textContent=i===questions.length-1?'See My Result →':'Next →';}
function start(){w.classList.add('hide');rbox.classList.add('hide');qbox.classList.remove('hide');render();root.scrollIntoView({behavior:'smooth',block:'start'});}
root.querySelector('[data-start]').onclick=start;back.onclick=function(){if(i>0){i--;render();}};next.onclick=function(){if(next.disabled)return;if(i<questions.length-1){i++;render();}else result();};
root.querySelector('[data-retake]').onclick=function(){ans=[null,null,null,[],null];i=0;start();};
function result(){var s={explore:0,glp1:0,peptide:0,whole:0,personal:0};questions.forEach(function(x,n){var picks=x.multi?ans[n]:[ans[n]];picks.forEach(function(k){if(k===null)return;var z=x.w[k];Object.keys(z).forEach(function(key){s[key]+=z[key];});});});var win='explore';if(ans[4]===3)win='personal';else{Object.keys(s).forEach(function(k){if(s[k]>s[win])win=k;});}
var R={
explore:["Exploring & Learning","You don't need to rush a decision. You need good information.","Explore the Soulful Wellness Education Library","Start with clear, research-backed education so you can understand your options at your own pace.","/pages/wellness-education"],
glp1:["GLP-1 Wellness Support","You're not just looking at a GLP-1. You're looking at the whole journey.","Explore GLP-1 & Transformation Support","Learn about GLP-1 wellness support, practical nutrition, hydration, protein, movement, recovery and informed questions.","/pages/wellness-education"],
peptide:["Peptide & Compound Education","You have questions. Good. Ask them.","Explore Peptide & Compound Education","Start with education on compounds, research, limitations, risks and the questions worth asking.","/pages/wellness-education"],
whole:["Whole-Body Wellness","Your body is bigger than one number, one symptom, or one product.","Explore Mind • Body • Soul Wellness","Begin with whole-person support for nutrition, hydration, movement, recovery, sleep, digestion and everyday wellness.","/pages/wellness-education"],
personal:["Personal Support With Renee","You don't need more tabs open. You need help making sense of them.","Peptide Navigation + Wellness Coaching","45-minute private 1:1 session • $65","/products/peptide-navigation-wellness-coaching"]}[win];
qbox.classList.add('hide');rbox.classList.remove('hide');root.querySelector('[data-rt]').textContent=R[0];root.querySelector('[data-rl]').textContent=R[1];root.querySelector('[data-rs]').textContent=R[2];root.querySelector('[data-rd]').textContent=R[3];var a=root.querySelector('[data-ra]');a.textContent='Continue →';a.href=R[4];var safe=root.querySelector('[data-safe]');safe.classList.toggle('hide',!(ans[3]||[]).includes(12));root.scrollIntoView({behavior:'smooth',block:'start'});}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBodyQuiz);else initBodyQuiz();document.addEventListener('shopify:section:load',initBodyQuiz);
})();
/* Soulful Wellness Quiz 2 runtime hotfix */
(function(){
 function bind(){
  var root=document.getElementById('swb'); if(!root) return;
  var start=root.querySelector('[data-start]'); if(!start||start.dataset.hotfix==='1') return;
  start.dataset.hotfix='1';
  start.addEventListener('click',function(){
   var w=root.querySelector('[data-s="w"]'),q=root.querySelector('[data-s="q"]');
   if(w)w.classList.add('hide'); if(q)q.classList.remove('hide');
   if(typeof initBodyQuiz==='function')initBodyQuiz();
   setTimeout(function(){ var n=root.querySelector('[data-next]'); if(n) n.disabled=true; },0);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
 document.addEventListener('shopify:section:load',bind);
 setTimeout(bind,500);setTimeout(bind,1500);
})();
